import Navbar from "../../components/general/Navbar";
import BuyerCheckoutCancel from "../../components/buyers/BuyerCheckoutCancel";
import Footer from "../../components/general/Footer";

export default function BuyerCheckoutCancelPage() {
  return (
    <>
      <Navbar />
      <BuyerCheckoutCancel />
      <Footer />
    </>
  )
}

